export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

export const ADMIN_RESERVATIONS_SEARCH_REQUEST = "ADMIN_RESERVATIONS_SEARCH_REQUEST";
export const ADMIN_RESERVATIONS_SEARCH_REQUEST_SUCCESS = "ADMIN_RESERVATIONS_SEARCH_REQUEST_SUCCESS";
export const ADMIN_RESERVATIONS_SEARCH_REQUEST_ERROR = "ADMIN_RESERVATIONS_SEARCH_REQUEST_ERROR ";

export const ADMIN_RESERVATIONS_MODIFY_REQUEST = "ADMIN_RESERVATIONS_MODIFY_REQUEST";
export const ADMIN_RESERVATIONS_MODIFY_REQUEST_SUCCESS = "ADMIN_RESERVATIONS_MODIFY_REQUEST_SUCCESS";
export const ADMIN_RESERVATIONS_MODIFY_REQUEST_ERROR = "ADMIN_RESERVATIONS_MODIFY_REQUEST_ERROR";